import { Text } from "components/Text"

export const AdvertTitle = ({ advert }) => {
  return <Text variant="headline5">{advert.title}</Text>
}
